var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsThreeOutlineVertical = function SvgDotsThreeOutlineVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.375a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25Zm0 4.5a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75Zm0-6.75a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Zm0-4.5a1.875 1.875 0 1 1 0 3.75 1.875 1.875 0 0 1 0-3.75Zm0 14.25a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25Zm0 4.5a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75Z",
    fill: "#fff"
  })));
};
export default SvgDotsThreeOutlineVertical;